import { useEffect, useState } from "react";
import "./AttributeNav.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { ChevronDown } from "lucide-react";
import ApiService from "../Api_services";
import ArrowDown from "../../assets/icons/Group 33921.svg";
import { useLocation, useSearchParams } from "react-router-dom";
import FallbackImg from "../FallbackImg";

const AttributeNav = ({ attributeList = [], disabled }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [openMain, setOpenMain] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [animationState, setAnimationState] = useState("");
  const [selectedProductGroup, setSelectedProductGroup] = useState("");

  const [attrData, setAttr] = useState([]);

  const handleToggle = (index) => {
    if (openIndex === index) {
      // Closing
      setAnimationState("closing");
      setTimeout(() => {
        setOpenIndex(null);
        setAnimationState("");
      }, 300); // Match CSS transition duration
    } else {
      // Opening
      setOpenIndex(index);
      setAnimationState("opening");
      setTimeout(() => {
        setAnimationState("");
      }, 300);
    }
  };

  const handleToggleMain = () => {
    setOpenMain(!openMain);
  };

  useEffect(() => {
    const attributesFromUrl = searchParams.get("attributes");
    setSelectedAttributes(
      attributesFromUrl ? attributesFromUrl.split(",") : [],
    );
  }, [searchParams]);

  const handleAttributeChange = (attrId, groupName) => {
    const group = attributeList.find((attr) => attr.name === groupName);
    const groupIds = group ? group.attribute.map((a) => a.id.toString()) : [];
    const filtered = selectedAttributes.filter((id) => !groupIds.includes(id));
    const newSelected = [...filtered, attrId];
    const newSearchParams = new URLSearchParams(searchParams);
    if (newSelected.length > 0) {
      newSearchParams.set("attributes", newSelected.join(","));
    } else {
      newSearchParams.delete("attributes");
    }
    setSearchParams(newSearchParams);
    setSelectedAttributes(newSelected);
  };

  return (
    <div className="attributenav_v2">
      <div className="attributenav-content_v2">
        <div className="attributenav-dropdown_v2">
          {attributeList.length > 0 && (
            <div className="attributemainitem-container_v2">
              <div
                className={`attributemainitem_v2 ${disabled ? " disabled" : ""}`}
                onClick={() => handleToggleMain()}
              >
                <strong>SPECIFICATIONS</strong>
                <ChevronDown size={16} className={openMain ? "rotate" : ""} />
              </div>

              {openMain &&
                attributeList.map((attr, index) => (
                  <div className="attributeitem-container_v2" key={index}>
                    <div
                      className="attributeitem_v2"
                      onClick={() => handleToggle(index + 1)}
                    >
                      <strong>{attr.name}</strong>
                      <ChevronDown
                        size={12}
                        className={openIndex === index + 1 ? "rotate" : ""}
                      />
                    </div>
                    {openIndex === index + 1 && (
                      <div
                        className={`attribute-dropdown-wrapper_v2 ${animationState}`}
                      >
                        <ul className="subattributelist_v2">
                          {attr.attribute.map((value, subIndex) => (
                            <li key={subIndex} className="subattributeitem_v2">
                              <input
                                type="radio"
                                id={`attribute-${value.id}`}
                                name={`attribute-group-${attr.name}`}
                                value={value.id}
                                checked={selectedAttributes.includes(
                                  value.id.toString(),
                                )}
                                onChange={() =>
                                  handleAttributeChange(
                                    value.id.toString(),
                                    attr.name,
                                  )
                                }
                              />
                              <label
                                htmlFor={`attribute-${value.id}`}
                                style={{ cursor: "pointer" }}
                              >
                                {value.name}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttributeNav;
